import { postFormData, delFormData } from '@/lib/api/client'
import type { ApiResponse } from '@/lib/api/types'

export type FileUploadCategory = 'DOCUMENT' | 'PROCUREMENT_DOCUMENT' | 'IMAGE' | 'GOZADE'

export interface FileUploadResponse {
  fileUrl: string
  publicId: string
}

export interface FileDeleteResponse {
  message: string
}

export class FileUploadService {

  async uploadFile(
    file: File,
    category: FileUploadCategory = 'IMAGE'
  ): Promise<ApiResponse<FileUploadResponse>> {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('fileUploadCategory', category)

    return await postFormData<ApiResponse<FileUploadResponse>>(
      'utils/private/upload-file',
      formData
    )
  }


  async deleteFile(fileUrl: string): Promise<ApiResponse<FileDeleteResponse>> {
    const formData = new FormData()
    formData.append('file', fileUrl)

    return await delFormData<ApiResponse<FileDeleteResponse>>(
      'utils/private/delete-file',
      formData
    )
  }
}

export const fileUploadService = new FileUploadService()

export default fileUploadService
